import { Injectable, Optional } from '@angular/core';
import { UserAttributes } from '@auth/auth/lib/models/user';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user/user.service';

/**
 * @deprecated Use ShellWindow to share objects across the Shell and MFEs
 */
@Injectable()
export class ShellService {
  /**
   * @deprecated Use ShellWindow.isMFE
   */
  readonly shownAsMfe = true;
  headerStatusSubject = new BehaviorSubject<any>(false);
  // userAttributesSubject is currently only being used by Analytics
  userAttributesSubject = new BehaviorSubject<Record<
    string,
    UserAttributes[]
  > | null>(null);
  constructor(@Optional() private userService?: UserService) {}

  changeUserAttributes(user: {
    userAttributes: Record<string, UserAttributes[]>;
  }): void {
    this.userAttributesSubject.next(user.userAttributes);
    this.userService?.setUser(user);
  }
}
